<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="视频id" prop="videoId" >-->
<!--        <a-input v-model="form.videoId" placeholder="请输入视频id" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('videoPerformer.performerNameDe')" prop="performerNameDe" >
        <a-input v-model="form.performerNameDe" :placeholder="$t('videoPerformer.inputPerformerNameDe')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('videoPerformer.performerNameEn')" prop="performerNameEn" >
        <a-input v-model="form.performerNameEn" :placeholder="$t('videoPerformer.inputPerformerNameEn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('videoPerformer.performerNameFr')" prop="performerNameFr" >
        <a-input v-model="form.performerNameFr" :placeholder="$t('videoPerformer.inputPerformerNameFr')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('videoPerformer.performerName')" prop="performerName" >
        <a-input v-model="form.performerName" :placeholder="$t('videoPerformer.inputPerformerName')" />
      </a-form-model-item>

<!--      <a-form-model-item label="演员姓名（西班牙语）" prop="performerNameEs" >-->
<!--        <a-input v-model="form.performerNameEs" placeholder="请输入演员姓名（西班牙语）" />-->
<!--      </a-form-model-item>-->


      <a-form-model-item :label="$t('videoPerformer.performerAvatar')" prop="performerAvatar" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.performerAvatar"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          :customRequest="handleChange"
        >
          <div v-if="form.performerAvatar" class="upload-image-wrapper">
            <img :src="form.performerAvatar" alt="logo"
                 style="height:104px;max-width:300px"/>
            <div v-if="uploadLoading" class="upload-mask">
              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>
            </div>
          </div>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('video.upload') }}</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item :label="$t('table.sort')" prop="sort" >
        <a-input-number :min="0" style="width: 100%;" :precision="0" v-model="form.sort" :placeholder="$t('videoPerformer.inputSort')" />
      </a-form-model-item>
<!--      <a-form-model-item label="是否禁用 0-否 1-是" prop="isBan" >-->
<!--        <a-input v-model="form.isBan" placeholder="请输入是否禁用 0-否 1-是" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入备注" />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideoPerformer, addVideoPerformer, updateVideoPerformer } from '@/api/videoPerformer/videoPerformer'
import UploadFileToOSS from '@/utils/upload-file-to-oss.js'
import UploadFileToVOD from "@/api/vod.js"
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      videoId: null,
      // 表单参数
      form: {
        id: null,

        videoId: null,

        performerName: null,
        performerNameEn: null,
        performerNameEs: null,
        performerNameFr: null,
        performerNameDe: null,

        performerAvatar: null,

        sort: null,

        isBan: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      uploadLoading: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        performerName: [
          { required: true, message: this.$t('videoPerformer.performerNameRequired'), trigger: 'blur' }
        ],
        performerNameEn: [
          { required: true, message: this.$t('videoPerformer.performerNameEnRequired'), trigger: 'blur' }
        ],
        // performerNameEs: [
        //   { required: true, message: '西班牙演员姓名不能为空', trigger: 'blur' }
        // ],
        performerNameFr: [
          { required: true, message: this.$t('videoPerformer.performerNameFrRequired'), trigger: 'blur' }
        ],
        performerNameDe: [
          { required: true, message: this.$t('videoPerformer.performerNameDeRequired'), trigger: 'blur' }
        ],
        performerAvatar: [
          { required: true, message: this.$t('videoPerformer.performerAvatarRequired'), trigger: 'change' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    beforeUpload (file) {
      const fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('video.uploadImage'))
        this.uploadLoading = false
        return false
      }
      this.form.performerAvatar = ''
      this.uploadLoading = true
    },
    onClose () {
      this.open = false
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        videoId: null,
        performerName: null,
        performerNameEn: null,
        performerNameEs: null,
        performerNameFr: null,
        performerNameDe: null,
        performerAvatar: null,
        sort: null,
        isBan: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (videoId) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('video.add')
      this.form.videoId = videoId
      this.videoId = videoId
      console.log(this.videoId)
      // 清除表单验证状态
      // this.$nextTick(() => {
      //   if (this.$refs.form) {
      //     this.$refs.form.clearValidate()
      //   }
      // })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids,videoId) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVideoPerformer({"id":id}).then(response => {
        this.form = response.data
        this.form.videoId = videoId
        this.videoId = videoId
        console.log(this.videoId)
        this.open = true
        this.formTitle = this.$t('video.edit')
        // 清除表单验证状态
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },

    handleChange(info) {
      let that = this
      that.uploadLoading = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.performerAvatar = fileName[0];//文件名
          that.uploadLoading = false;
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('performerAvatar')
            }
          })
        },
        error: function () {
          that.uploadLoading = false;
          that.$message.error(that.$t('video.uploadFailed'));
        }
      });
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(11111111111)
      console.log(this.videoId)

      this.form.videoId=this.videoId
      console.log(this.form)
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            this.form.videoId=this.videoId
            updateVideoPerformer(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            this.form.videoId=this.videoId
            console.log(this.form)
            console.log(this.videoId)
            addVideoPerformer(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
